import type {
	AddCounterpartyFormValues,
	AssignableUser,
	SlotFormValues,
	SlotSubmission,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/AddCounterparty/AddCounterpartyModal.types';

/** A blank slot, open until someone chooses to assign or invite. */
export const emptySlot = (): SlotFormValues => ({
	mode: 'UNASSIGNED',
	userId: '',
	firstName: '',
	lastName: '',
	email: '',
});

/** Only the rendered slots are submitted, and only the branch the manager chose is sent — values
 *  left behind by switching modes must not reach the endpoint, which refuses a slot carrying both. */
export function toSlotSubmissions(values: AddCounterpartyFormValues): SlotSubmission[] {
	return values.slots.slice(0, values.slotCount).map((slot) => {
		if (slot.mode === 'USER') {
			return { userId: slot.userId };
		}
		if (slot.mode === 'INVITE') {
			return {
				invite: {
					firstName: slot.firstName.trim(),
					lastName: slot.lastName.trim(),
					email: slot.email.trim(),
				},
			};
		}
		return {};
	});
}

/** Programme users as the slot picker wants them: an id and one display label. */
export function toAssignableUsers(
	programmeUsers: ReadonlyArray<{
		id: string;
		firstName?: string | null;
		lastName?: string | null;
		email?: string | null;
	}>
): AssignableUser[] {
	return programmeUsers.map((user) => {
		const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
		return { id: user.id, label: fullName || user.email || user.id };
	});
}
